<div class="integrations-page">
    <div class="integrations-page__layout">

        <!-- All integrations in one unified Verbunden/Verfügbar split. Bexio (per-company)
             and D365 BC (per-org) both render through the same overview + universal card. -->
        <section class="integrations-page__section integrations-page__section--full">
            <aumico-company-integrations-overview
                *ngIf="companyId"
                [companyId]="companyId"
                [connectionMappings]="companyConnectionMappings"
                [perCompanyState]="perCompanyVendorState"
                [isAdmin]="(isAdmin$ | async) ?? false"
                (perCompanyInfoClick)="onPerCompanyInfo($event)"
                (goToAdmin)="onGoToOrgSettings()">
            </aumico-company-integrations-overview>
        </section>

        <!-- Integration Vote Leaderboard (full width, below) -->
        <section class="integrations-page__section integrations-page__section--full">
            <h2 class="integrations-page__section-title">{{ 'aumico_companies_integrations_leaderboard_title' | i18next }}</h2>
            <p class="integrations-page__section-subtitle">{{ 'aumico_companies_integrations_leaderboard_subtitle' | i18next }}</p>

            <div class="integration-leaderboard__cta">
                <p class="integration-leaderboard__cta-text">
                    {{ 'aumico_companies_integrations_suggestion_cta_text' | i18next }}
                </p>
                <button type="button" class="integration-leaderboard__cta-btn" (click)="onOpenSuggestionModal()">
                    {{ 'aumico_companies_integrations_suggestion_cta_button' | i18next }}
                </button>
            </div>

            <div class="integration-leaderboard" *ngIf="!isLeaderboardLoading; else leaderboardLoading">
                <article class="integration-leaderboard__item" *ngFor="let item of integrationLeaderboard; let idx = index">
                    <div class="integration-leaderboard__rank">#{{ idx + 1 }}</div>
                    <div class="integration-leaderboard__body">
                        <div class="integration-leaderboard__head">
                            <h3 class="integration-leaderboard__name">
                                {{ ('aumico_companies_integrations_name_' + item.integration) | i18next }}
                            </h3>
                            <p class="integration-leaderboard__votes">
                                <strong>{{ item.votes }}</strong>
                                {{ 'aumico_companies_integrations_votes_label' | i18next }}
                            </p>
                        </div>
                        <div class="integration-leaderboard__progress">
                            <span class="integration-leaderboard__progress-fill" [style.width.%]="getVoteBarWidth(item.votes)"></span>
                        </div>
                    </div>
                    <button
                        type="button"
                        class="integration-leaderboard__vote-btn"
                        [disabled]="item.hasVoted || votingIntegration === item.integration"
                        (click)="onOpenVoteModal(item.integration)">
                        {{ (item.hasVoted ? 'aumico_companies_integrations_btn_voted' : 'aumico_companies_integrations_btn_upvote') | i18next }}
                    </button>
                </article>
            </div>

            <ng-template #leaderboardLoading>
                <div class="integration-leaderboard__loading">{{ 'aumico_loading' | i18next }}</div>
            </ng-template>
        </section>
    </div>

</div>

<!-- Bexio info modal (per-company): info text + the actual connect/disconnect action. -->
<ham-modal
    *ngIf="showBexioInfoModal"
    [title]="'aumico_companies_integrations_name_bexio' | i18next"
    [saveText]="(isBexioConnected ? 'aumico_companies_integrations_btn_disconnect' : 'aumico_companies_integrations_btn_connect') | i18next"
    [saveVariant]="isBexioConnected ? 'red' : 'primary'"
    [cancelText]="'aumico_button_cancel' | i18next"
    [showCancelButton]="true"
    [size]="'sm'"
    (save)="onBexioModalPrimary()"
    (cancel)="onCloseBexioInfoModal()">

    <div class="integration-modal-content">
        <p class="integration-modal-content__hint">
            {{ (isBexioConnected
                ? 'aumico_company_integration_bexio_modal_connected'
                : 'aumico_company_integration_bexio_modal_disconnected') | i18next }}
        </p>
    </div>
</ham-modal>

<ham-modal
    *ngIf="showVoteModal"
    [title]="'aumico_companies_integrations_vote_modal_title' | i18next"
    [saveText]="'aumico_companies_integrations_vote_modal_submit' | i18next"
    [cancelText]="'aumico_button_cancel' | i18next"
    [showCancelButton]="true"
    [disabled]="votingIntegration != null"
    (save)="onVoteForIntegration()"
    (cancel)="onCancelVoteModal()">

    <div class="integration-modal-content">
        <p class="integration-modal-content__hint">
            {{ 'aumico_companies_integrations_vote_modal_hint' | i18next }}
        </p>
        <p class="integration-modal-content__integration" *ngIf="voteModalIntegration != null">
            <strong>{{ ('aumico_companies_integrations_name_' + voteModalIntegration) | i18next }}</strong>
        </p>
        <label class="integration-modal-content__label">
            {{ 'aumico_companies_integrations_vote_modal_label' | i18next }}
        </label>
        <textarea
            class="integration-modal-content__textarea"
            [placeholder]="'aumico_companies_integrations_vote_modal_placeholder' | i18next"
            [value]="voteModalMessage"
            (input)="voteModalMessage = $any($event.target).value"
            rows="4">
        </textarea>
    </div>
</ham-modal>

<ham-modal
    *ngIf="showSuggestionModal"
    [title]="'aumico_companies_integrations_suggestion_modal_title' | i18next"
    [saveText]="'aumico_button_submit' | i18next"
    [cancelText]="'aumico_button_cancel' | i18next"
    [showCancelButton]="true"
    [disabled]="isSubmittingSuggestion || suggestionMessage.trim().length === 0"
    (save)="onSubmitSuggestion()"
    (cancel)="onCancelSuggestionModal()">

    <div class="integration-modal-content">
        <p class="integration-modal-content__hint">
            {{ 'aumico_companies_integrations_suggestion_modal_hint' | i18next }}
        </p>
        <label class="integration-modal-content__label">
            {{ 'aumico_companies_integrations_suggestion_modal_label' | i18next }}
        </label>
        <textarea
            class="integration-modal-content__textarea"
            [placeholder]="'aumico_companies_integrations_suggestion_modal_placeholder' | i18next"
            [value]="suggestionMessage"
            (input)="suggestionMessage = $any($event.target).value"
            rows="5">
        </textarea>
    </div>
</ham-modal>
